module.exports = __webpack_public_path__ + "d57b08a549f59433963ee029265c48ca.png";